import React from 'react';
import { Box, Container, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useCookieConsent } from '../context/CookieConsentContext';
import './Footer.css';

function Footer({ ref }) {
  const { setShowBanner } = useCookieConsent();

  const handleCookieSettingsClick = event => {
    event.preventDefault();
    setShowBanner(true);
  };

  return (
    <Box id="footer" component="footer" ref={ref}>
      <Container maxWidth="lg" className="footer-container footer-links-wrapper">
        <Box className="footer-links-box">
          <nav aria-label="Fußzeilennavigation">
            <ul className="footer-links-list">
              <li className="footer-links-list-item">
                <Link
                  href="https://static.assona.com/RuV-Hardware/RUV_HW_2025/R+V_DE_Erst_Kundeninformation_Hardware_Versicherung.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  variant="body2"
                  className="footer-link"
                >
                  Erstinformation
                </Link>
              </li>
              <li className="footer-links-list-item">
                <Link
                  href="https://static.assona.com/RuV-Hardware/RUV_HW_2025/2025-06-28_DE_DE_RUV_HWV.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  variant="body2"
                  className="footer-link"
                >
                  Versicherungsbedingungen
                </Link>
              </li>
              <li className="footer-links-list-item">
                <Link component={RouterLink} to="/datenschutz" variant="body2" className="footer-link">
                  Datenschutz
                </Link>
              </li>
              <li className="footer-links-list-item">
                <Link
                  href="https://assona.com/impressum/"
                  target="_blank"
                  rel="noopener noreferrer"
                  variant="body2"
                  className="footer-link"
                >
                  Impressum
                </Link>
              </li>
              <li className="footer-links-list-item">
                <Link
                  href="#"
                  onClick={handleCookieSettingsClick}
                  variant="body2"
                  className="footer-link"
                  aria-label="Datenschutz-Einstellungen"
                >
                  Datenschutz-Einstellungen
                </Link>
              </li>
            </ul>
          </nav>
        </Box>
      </Container>
    </Box>
  );
}

export default Footer;
